import { useLocation } from 'react-router-dom';
import { parsePreviewFileIdFromPath } from '../../lib/previewRoutePath';

/** Preview modal file id — the URL is the only source of truth for open/closed. */
export function usePreviewFileId(): string | undefined {
  return parsePreviewFileIdFromPath(useLocation().pathname);
}

export default usePreviewFileId;
